import styled from 'styled-components';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 45px 1fr;
  column-gap: 25px;
  row-gap: 55px;
  margin-bottom: 50px;
`;

export default Wrapper;
